import TypographyParagraph from '../typography/TypographyParagraph'

const Bulk = ({
	metadata,
	asCountersign = false,
}: {
	metadata: any
	asCountersign?: boolean
}) => {
	return (
		<div className="flex flex-col">
			<div
				className={`${asCountersign ? 'border-b border-textInactiveLight px-4 py-2 dark:border-textInactiveDark' : ''}`}
			>
				<TypographyParagraph
					size="medium"
					additionalClasses="mb-4 text-textPrimaryLight dark:text-textPrimaryDark"
				>
					Bulk CID: {metadata.properties.bulkCID}
				</TypographyParagraph>
			</div>
		</div>
	)
}

export default Bulk
